import React, { useContext, useState, useEffect } from 'react'
import { supabase } from '../supabase'
import { Grid } from "react-loader-spinner";

const AuthContext = React.createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let session = supabase.auth.session()
    if (session?.user) {
      setUser(session?.user ?? null)
      setLoading(false)
    } else {
      // TODO: !!!DANGEROUS!!! Delays 1 second if we couldn't find a user in session
      // This was intended for redirection after email confirmation
      // But also affects all page loads where session isn't available
      setTimeout(() => {
        session = supabase.auth.session()
        setUser(session?.user ?? null)
        setLoading(false)
      }, 1000)
    }

    const { data: listener } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        setUser(session?.user ?? null)
        setLoading(false)
      }
    )

    return () => {
      if (listener) listener.unsubscribe()
    }
  }, [])

  const value = {
    signUp: (data) => supabase.auth.signUp(data),
    signIn: (data) => supabase.auth.signIn(data),
    signOut: () => supabase.auth.signOut(),
    user,
  }

  return (
    <AuthContext.Provider value={value}>
      {
        loading ?
          <div className="h-screen grid place-items-center">
            <Grid type="Grid" color="#3b82f6" height="56" width="56" />
          </div> :
          children
      }
    </AuthContext.Provider>
  )
}
